import Card from '@uikit/components/Card/Card';
import type { PressRelatedArticlesProps } from './interfaces';
import styles from './PressRelatedArticles.module.scss';

const PressRelatedArticles = ({ items, tag }: PressRelatedArticlesProps) => {
  const cards = items.map((props) => (
    <article key={props.headline}>
      <Card
        headline={props.headline}
        text={props.text}
        linkintern={props.linkintern}
        tag={props.tag}
        image={props.image}
        mediaType={props.mediaType}
        date={props.date}
      />
    </article>
  ));

  return (
    <div>
      <h2 className={styles.headline}>Mehr zum Thema {tag}</h2>

      <div className={styles.base}>{cards}</div>
    </div>
  );
};

export default PressRelatedArticles;
